const makeSelectVisibleFields = form => state => state.form[form].visibleFields;

export default makeSelectVisibleFields;
